import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentClaimsPage() {
  return <LatamAgentPage locale="es-CO" agentKey="claims_processing" />;
}
